import axios from 'axios'

export const getShifts = (params, config = {}) => {
  return axios.get('/pos/shifts', { params, ...config })
}

export const addShift = (data, config = {}) => {
  return axios.post('/pos/shifts', data, config)
}

export const editShift = (data) => {
  return axios.patch(`/pos/shifts/${data.id}`, data)
}

export const closeShift = (data, config = {}) => {
  return axios.patch(`/pos/shifts/${data.id}/end`, data, config)
}

export const getShift = (id, config = {}) => {
  return axios.get(`/pos/shifts/${id}`, config)
}

export const getCurrentShift = (params, config = {}) => {
  return axios.get('/pos/shifts/current', { params, ...config })
}

// Device yang masih aktif pada shift (multi-device). Bentuk: { data: { devices: [{device_id, nickname}] } }
export const getShiftDevices = (shiftId, config = {}) => {
  return axios.get(`/pos/shifts/${shiftId}/devices`, config)
}

// Catat browser ini ikut memakai shift (melanjutkan shift milik device lain).
export const recordShiftDevice = (shiftId, data, config = {}) => {
  return axios.post(`/pos/shifts/${shiftId}/devices`, data, config)
}
